export const tagPlayerAsUnavailable = player => {
    player.style.backgroundColor = "rgba(255,255,255,0.1)";

    const errorMessage = document.createElement("div");
    player.parentNode.appendChild(errorMessage);
    errorMessage.className = "video-error-message";
    errorMessage.innerHTML = "<span>This data is not yet available. <br/>Please try again later.</span>";
};
